var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"round-button",attrs:{"color":"primary","elevation":0,"dark":"","rounded":"","height":46,"width":46}},'v-btn',_vm.attrs,false),_vm.on),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }